import Reveal from "@/components/base/Reveal";
import { aboutTechnologyPoints } from "@/mocks/about";

export default function AboutTechnology() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="shell">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div>
              <span className="inline-flex items-center gap-2.5 text-[11px] font-bold uppercase tracking-[0.24em] text-primary-600">
                <span className="h-px w-7 bg-primary-400" aria-hidden="true" />
                Teknolojimiz
              </span>
              <h2 className="mt-5 font-heading text-3xl font-medium leading-tight tracking-tight text-foreground-950 md:text-4xl">
                Modern dijital, düşük doz
              </h2>
              <p className="mt-6 text-base leading-relaxed text-foreground-600">
                Merkezimizde modern dijital panoramik ve Konik Işınlı Bilgisayarlı Tomografi (CBCT)
                cihazları kullanılmaktadır. Dijital çekim, klasik analog yöntemlere göre birçok kritik
                avantaj sağlar.
              </p>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                Her cihazın kalibrasyonu düzenli olarak kontrol edilir; görüntüleme protokolleri klinik
                endikasyona göre seçilir. ALARA prensibiyle gereksiz dozdan kaçınılır, endikasyonu net
                olmayan çekim yapılmaz.
              </p>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                Çekim sonrası raporlama aşamasında görüntüler uzman radyoloji gözünden geçirilir;
                hekiminize hem ham veri hem de değerlendirme notu iletilir.
              </p>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="relative overflow-hidden rounded-xl border border-background-200 bg-background-100 p-7 md:p-8">
              <span
                className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/70 to-transparent"
                aria-hidden="true"
              />
              <h3 className="font-heading text-lg font-medium tracking-tight text-foreground-950">
                Dijital çekimin avantajları
              </h3>
              <ul className="mt-6 flex flex-col divide-y divide-background-200">
                {aboutTechnologyPoints.map((point) => (
                  <li key={point} className="flex items-start gap-3 py-3.5">
                    <i className="ri-check-double-line mt-0.5 text-base text-primary-600" aria-hidden="true" />
                    <span className="text-sm text-foreground-700">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}